import DjangoMessages from 'components/DjangoMessages';
import SectionHeader from 'components/SectionHeader';
import {FormProvider, useForm} from 'react-hook-form';
import {t} from 'ttag';

import Filter from './components/filter';
import List from './components/list';

const initialSearchQuery = () =>
    new URLSearchParams(window.location.search).get('search') || '';

const LineItemCatalogList = () => {
    const methods = useForm({
        defaultValues: {
            search: initialSearchQuery(),
        },
    });
    return (
        <FormProvider {...methods}>
            <div className="flex flex-col gap-4">
                <DjangoMessages />
                <SectionHeader
                    subtitle={t`Create Catalog Items to help speed up line item entry in your Documents.`}
                    title={t`Line Item Catalog`}
                />
                <Filter />
                <List />
            </div>
        </FormProvider>
    );
};
export default LineItemCatalogList;
